import barba from '@barba/core';
import { EE } from './../utils/ee';

class Cursor {
  constructor(root) {
    this.root = root;
    this.cursor = this.root.querySelector('[data-cursor--cursor]');
    this.modes = [...this.root.querySelectorAll('[data-cursor--mode]')].map(el => {
      return {
        el,
        name: el.getAttribute('data-cursor--mode'),
      }
    });

    this.bind();
  }

  bind() {
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onEnterCard = this.onEnterCard.bind(this);
    this.onLeaveCard = this.onLeaveCard.bind(this);

    EE.on('enter-card', this.onEnterCard);
    EE.on('leave-card', this.onLeaveCard);

    barba.hooks.beforeLeave(() => {
      this.hide();
    });

    window.addEventListener('mousemove', this.onMouseMove);
  }

  onEnterCard(args) {
    if (args.ctx !== 'cursor') { return }
    this.show(args.mode ? args.mode : 'default');
  }

  onLeaveCard(args) {
    if (args.ctx !== 'cursor') { return }
    this.hide();
  }

  show(name = 'default') {
    this.modes.forEach(mode => {
      if (mode.name === name) {
        mode.el.classList.add('opacity-100');
        mode.el.classList.remove('opacity-0');
      } else {
        mode.el.classList.remove('opacity-100');
        mode.el.classList.add('opacity-0');
      }
    });

    document.body.classList.add('cursor-visible');
  }

  hide() {
    document.body.classList.remove('cursor-visible');
  }

  onMouseMove(e) {
    const { clientX, clientY } = e;
    this.cursor.style.transform = `translate(${clientX}px, ${clientY}px)`;
  }

  unbind() {
    EE.removeListenner('enter-card', this.onEnterCard);
    EE.removeListenner('leave-card', this.onLeaveCard);

    this.document.removeEventListener('mousemove', this.onMouseMove);
  }

  destroy() {
    this.unbind();
  }
}

export default {
  when() {
    return document.querySelectorAll('[data-cursor]').length > 0
  },

  mounted() {
    this.instances = [];

    document.querySelectorAll('[data-cursor]').forEach(cursor => {
      const instance = new Cursor(cursor);
      this.instances.push(instance);
    })
  },
}
